import React from 'react';

interface InputProps {
  name: string;
  label?: string;
  id?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  className?: string;
  placeholder?: string;
  type?: string;
  value?: any;
  min?: string;
  max?: string;
  autoComplete?: string;
  title?: string;
  onBlur?: (_: any, name: string) => void;
  onKeyDown?: (_: any) => void;
  onChange?: (_: any, name: string) => void;
}

const Input: React.FC<InputProps> = ({
  label,
  id,
  disabled,
  name,
  required,
  error,
  errorMessage,
  className,
  placeholder,
  type,
  value,
  min,
  max,
  autoComplete,
  title,
  onBlur,
  onKeyDown,
  onChange,
}) => {
  return (
    <div className="w-100 text-start">
      {label && (
        <label
          htmlFor={id}
          className="form-label text-uppercase d-block mb-2"
          style={{ fontSize: '10px', letterSpacing: '0.16em', color: 'var(--dim)', fontFamily: 'var(--font-sans)', display: 'block', textTransform: 'uppercase', marginBottom: '6px' }}
        >
          {label} {required && <span className="text-danger" style={{ color: 'var(--red)' }}>*</span>}
        </label>
      )}
      <input
        id={id}
        name={name}
        className={`form-control ${error ? 'is-invalid' : ''} ${className || ''}`}
        placeholder={placeholder}
        type={type}
        value={value}
        min={min}
        max={max}
        autoComplete={autoComplete || 'off'}
        title={title}
        onBlur={(e) => onBlur && onBlur(e, name)}
        onKeyDown={onKeyDown}
        onChange={(e) => onChange && onChange(e, name)}
        disabled={disabled}
        required={required}
      />
      {error && (
        <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback d-block mt-1">
          <div data-field={id} data-validator="notEmpty" className="text-danger extra-small" style={{ fontSize: '12px', marginTop: '4px' }}>
            {errorMessage}
          </div>
        </div>
      )}
    </div>
  );
};

export default Input;
